/**
 * PmMorphIcon 描边随尺寸变化（absoluteStrokeWidth=true 时按像素档位手配，非全局固定值）。
 * 锚点：16px → 1.25，24px → 1.5；中间线性插值，更大尺寸按同斜率外推。
 */
export const PM_MORPH_STROKE_ANCHORS = {
  16: 1.25,
  24: 1.5,
};

const STROKE_SLOPE = (PM_MORPH_STROKE_ANCHORS[24] - PM_MORPH_STROKE_ANCHORS[16]) / (24 - 16);

/** @param {number} pixelSize */
export function pmMorphStrokeWidthForSize(pixelSize) {
  const size = Number(pixelSize);
  if (!Number.isFinite(size) || size <= 16) return PM_MORPH_STROKE_ANCHORS[16];
  const width = PM_MORPH_STROKE_ANCHORS[16] + (size - 16) * STROKE_SLOPE;
  return Math.round(width * 100) / 100;
}

/** @deprecated 使用 pmMorphStrokeWidthForSize(24) */
export const PM_MORPH_ICON_STROKE_WIDTH = PM_MORPH_STROKE_ANCHORS[24];
